









































import { defineComponent, PropType, ref } from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import FormError from '@front-app/components/form/FormError.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import TrForm from '@front-app/components/form/Form.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import { GroupRoleRequest } from '@front-app/services/GroupsApi/GroupsMemberApi';
import { required } from '@front-app/components/form/validation/validators';
import { Size } from '@front-app/components/constants';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { useGroupMemberStateChange } from '@front-app/modules/group/hooks/useGroupMemberStateChange';
import { v } from '@front-app/components/form/validation/useValidation';

export default defineComponent({
	components: {
		CtaButton,
		ErrorCard,
		FormError,
		FormInput,
		FormLabel,
		FormSection,
		PaddedContent,
		TrForm,
	},
	props: {
		group: {
			type: Object as PropType<GroupWithCommunity>,
			required: true,
		},
	},
	setup(props) {
		const accessCode = ref('');

		// Submit
		const validation = v({
			accessCode: {
				value: accessCode,
				rules: [required()],
			},
		});
		const { focusFirstInvalid } = useFocusFirstInvalidField({ containerSelector: '#access-code-form' });

		const {
			request: requestStateChange,
			isChangingState: isJoining,
			isErrorJoining,
		} = useGroupMemberStateChange();
		const enterAccessCode = () => {
			if (!props.group) {
				return;
			}

			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}

			requestStateChange(props.group.id, GroupRoleRequest.CODE, '', accessCode.value);
		};

		return {
			accessCode,
			validation,
			isJoining,
			isErrorJoining,
			enterAccessCode,
			// Util
			ButtonPalettes,
			Size,
		};
	},
});
